import $foreign from "./foreign.cjs";
var intercalate = $foreign.intercalate;
export { intercalate };
